import { Component, OnInit, Inject } from '@angular/core';
import { User } from 'src/app/_models/user';
import { UserService } from 'src/app/_service/user.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})

export class UpdateUserComponent implements OnInit {

user1 = {
  emailAddress: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    country: '',
    city: '',
    province: '',
    faxNumber: '',
    phoneNumber: '',
    postalCode: '',
    userOutsideId: '',
    createdDate: '',
    notes: ''
};

user = {
  emailAddress: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    country: '',
    city: '',
    province: '',
    faxNumber: '',
    phoneNumber: '',
    postalCode: '',
    userOutsideId: '',
    createdDate: '',
    notes: ''
};

updateUserForm: FormGroup;


  constructor(private userService: UserService,
    private alertify: AlertifyService,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    ) {
      this.updateUserForm = fb.group({
        emailFormControl: new FormControl('', []).clearValidators(),
        firstNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(50),
          this.WhitespaceValidator
        ]),
        lastNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(70),
          this.WhitespaceValidator
        ]),
        postalCodeFormControl : new FormControl('', [
        ]).clearValidators(),
        addressLine1FormControl : new FormControl('', [
        ]).clearValidators(),
        addressLine2FormControl : new FormControl('', []).clearValidators(),
        countryFormControl : new FormControl('', [
        ]).clearValidators(),
        cityFormControl : new FormControl('', [
        ]).clearValidators(),
        provinceFormControl : new FormControl('', [
        ]).clearValidators(),
        faxNumberFormControl : new FormControl('', [
        ]).clearValidators(),
        phoneNumberFormControl : new FormControl('', [
        ]).clearValidators(),
        createdDateFormControl: new FormControl('', []).clearValidators(),
        notesFormControl: new FormControl('', []).clearValidators()
      });
    }

    firstName = this.passedData.user.firstName;

    userOutsideId = this.passedData.user.userOutsideId;

    public WhitespaceValidator(control: FormControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    this.loadUser();
  }

  updateUser() {
    this.userService.updateUserInfo(this.userOutsideId, this.user).subscribe(
      (response: any) => {
        const successMessage = response.headers && response.headers.get('UserUpdateSuccess');
        if (successMessage) {
          this.alertify.success(successMessage);
        } else {
          this.alertify.success('User profile updated successfully');
        }
      }, 
      (error) => {
        const errorMessage = error.headers && error.headers.get('UserUpdateFailed');
        const emailChanged = error.headers && error.headers.get('EmailChanged');
        const restrictedAccess = error.headers && error.headers.get('RestrictedAccess');
        
        if (emailChanged) {
          this.alertify.warning(emailChanged);
        } else if (restrictedAccess) {
          this.alertify.warning(restrictedAccess);
        } else if (errorMessage) {
          this.alertify.error(errorMessage);
        } else {
          this.alertify.error('Failed to update user profile. Please try again.');
        }
      }
    );
  }

  loadUser() {
    this.userService.getUser(this.userOutsideId).subscribe((user: User) => {
      this.user = user;
    },
    error => {
      this.alertify.error("Something went wrong. Please try again later.");
    });
  }
}